import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DestinyGPTChat from './components/DestinyGPTChat';
import SEOSchema from '../../components/feature/SEOSchema';

const siteUrl = 'https://destinygpt.com';

const destinySchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/destiny-gpt`,
    url: `${siteUrl}/destiny-gpt`,
    name: '데스티니 GPT — AI 사주 기반 인생 결정 비서 | 데스티니AI 포춘',
    description: '데스티니 GPT 결정 비서 — 직장 전환, 결혼, 이사, 창업, 투자 등 인생의 중대한 결정을 사주(四柱)와 오행(五行)으로 최적의 시기와 방향을 분석합니다. 데스티니AI 포춘 서비스.',
    inLanguage: 'ko-KR',
    isPartOf: { '@type': 'WebSite', url: `${siteUrl}/`, name: '데스티니GPT' },
    dateModified: '2026-03-17',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${siteUrl}/destiny-gpt#service`,
    name: '데스티니 GPT — 사주 기반 인생 결정 비서',
    alternateName: ['Destiny GPT', '데스티니AI 포춘 결정 비서'],
    description: '직장 전환, 결혼, 이사, 창업, 투자 등 인생의 중대한 결정을 사주(四柱)와 오행(五行)으로 최적의 시기와 방향을 분석합니다. 데스티니 GPT AI 운세 서비스.',
    url: `${siteUrl}/destiny-gpt`,
    provider: {
      '@type': 'Organization',
      name: '데스티니GPT',
      alternateName: 'Destiny GPT',
      url: siteUrl,
    },
    serviceType: '사주 기반 인생 결정 AI 분석',
    areaServed: { '@type': 'Country', name: '대한민국' },
    inLanguage: 'ko-KR',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'KRW',
      description: '무료 체험 제공',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '데스티니 GPT 결정 비서는 어떤 서비스인가요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '데스티니 GPT는 사주팔자와 오행 이론을 AI로 분석해 직장 전환·결혼·이사·창업·투자 등 인생 중대 결정의 최적 시기와 방향을 알려주는 데스티니AI 포춘 서비스입니다.',
        },
      },
      {
        '@type': 'Question',
        name: '데스티니 GPT는 어떤 카테고리의 결정을 도와주나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '데스티니 GPT는 직장·커리어, 연애·결혼, 이동·이사, 창업·사업, 재물·투자, 건강 등 6가지 인생 카테고리에 대한 AI 사주 운세 분석을 제공합니다.',
        },
      },
      {
        '@type': 'Question',
        name: '데스티니AI 포춘의 사주 분석은 어떻게 이루어지나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '데스티니AI 포춘은 생년월일·출생 시간을 기반으로 사주팔자(四柱八字)를 산출하고, AI가 대운(大운)·세운(歲운)·오행(五行) 균형을 분석해 최적의 결정 시기를 제시합니다.',
        },
      },
    ],
  },
];

const DECISION_STATS = [
  { label: '분석 완료 결정', value: '84,000+', icon: 'ri-scales-3-line' },
  { label: '만족도', value: '97%', icon: 'ri-thumb-up-line' },
  { label: '인생 카테고리', value: '6가지', icon: 'ri-grid-fill' },
  { label: '운세 데이터 기반', value: '사주 · 오행 · 타이밍', icon: 'ri-database-2-line' },
];

const DECISION_PRINCIPLES = [
  {
    icon: 'ri-time-line',
    title: '시기(時期)의 법칙',
    desc: '아무리 옳은 결정도 때를 잘못 택하면 수배의 노력이 필요합니다. 대운(大운)과 세운(歲운)이 일치하는 최적의 타이밍을 분석합니다.',
    color: 'from-amber-500 to-orange-500',
  },
  {
    icon: 'ri-compass-3-line',
    title: '방향(方向)의 법칙',
    desc: '오행(五行)과 상생하는 방향으로 움직일 때 에너지 소모가 최소화됩니다. 진로·이동·투자 방향을 명조와 맞춥니다.',
    color: 'from-emerald-500 to-teal-500',
  },
  {
    icon: 'ri-user-star-line',
    title: '귀인(貴人)의 법칙',
    desc: '모든 중대한 결정에는 당신을 도와줄 귀인이 있습니다. 사주에서 귀인 출현 시기와 유형을 파악해 인연을 최대한 활용하세요.',
    color: 'from-violet-500 to-purple-600',
  },
];

export default function DestinyGPTPage() {
  return (
    <div className="min-h-screen bg-primary-dark text-white">
      <SEOSchema schema={destinySchema} id="destiny-schema" />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-28 sm:pt-36 pb-16 sm:pb-20 px-4 sm:px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/806a7d6c099cb2618857493eb52a581c.jpg"
            alt="Destiny GPT background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/70 via-primary-dark/60 to-primary-dark"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-gold/15 border border-primary-gold/40 mb-6">
            <i className="ri-scales-3-line text-primary-gold text-sm"></i>
            <span className="text-primary-gold text-sm font-semibold tracking-widest uppercase">Destiny GPT</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-5 leading-tight">
            당신이 좋은 결정을<br />
            <span className="text-gradient">하길 바랍니다</span>
          </h1>
          <p className="text-lg sm:text-xl text-purple-200/90 mb-4 leading-relaxed max-w-2xl mx-auto">
            평생 운세 기반 중대 결정 비서
          </p>
          <p className="text-base text-purple-300/70 mb-10 max-w-xl mx-auto leading-relaxed">
            직장 전환, 결혼, 이사, 창업, 투자 — 인생의 모든 중대한 기로에서 사주(四柱)와 오행(五行)으로 최적의 시기와 방향을 제시합니다.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {DECISION_STATS.map((stat) => (
              <div key={stat.label} className="glass-card rounded-2xl px-4 py-3 text-center">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1">
                  <i className={`${stat.icon} text-primary-gold text-lg`}></i>
                </div>
                <p className="text-white font-bold text-sm sm:text-base">{stat.value}</p>
                <p className="text-purple-300/60 text-xs mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Three Principles */}
      <section className="relative py-12 sm:py-16 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          <p className="text-center text-purple-300/60 text-sm uppercase tracking-widest mb-8">Destiny GPT 3대 원칙</p>
          <div className="grid md:grid-cols-3 gap-5">
            {DECISION_PRINCIPLES.map((p) => (
              <div key={p.title} className="glass-card rounded-2xl p-6 border border-white/10 hover:border-primary-gold/30 transition-all duration-300">
                <div className={`w-12 h-12 flex items-center justify-center rounded-2xl bg-gradient-to-br ${p.color} mb-4`}>
                  <i className={`${p.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-white font-bold text-base mb-2">{p.title}</h3>
                <p className="text-purple-300/70 text-sm leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Chat Interface */}
      <section className="relative py-10 sm:py-14 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              지금 바로 <span className="text-gradient">결정 상담</span> 시작하기
            </h2>
            <p className="text-purple-300/70 text-sm">카테고리를 선택하고 고민을 입력하면 Destiny GPT가 운세 기반 분석을 제공합니다</p>
          </div>
          <DestinyGPTChat />
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-10 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="glass-card rounded-2xl p-6 border border-white/10">
            <i className="ri-information-line text-purple-300/50 text-2xl mb-3 block"></i>
            <p className="text-purple-300/50 text-xs leading-relaxed">
              Destiny GPT는 동양 철학의 사주팔자와 오행 이론을 기반으로 한 운세 분석 서비스입니다. 제공되는 내용은 참고 목적이며, 실제 중요한 결정은 본인의 판단과 전문가 상담을 병행하시기 바랍니다.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
